<template lang="pug">
.rc
  //第一層
  template(v-if="specialArticles !== null && specialArticles.length !== 0")
    div(
      v-for="(layer, layerIndex) in showLayerData"
      :class="`rcBlock${layerIndex+1}`"
    )
      a(
        v-for="(item, i) in layer" 
        :class="`rcCard-base rcCard${layerIndex+1}`"
        :key="item.id" 
        :href="item.url"
        target="blank"
      )
        ImgLoader.img(
          :img="item.cover_photo" 
          :alt="'沒有圖片'"
          :style="{'--bgPos': 'center'}"
        ) 
        //背景
        div(:class="`rcCircle${layerIndex+1}`")
          div(:class="`rcTitle${layerIndex+1}`")  {{ item.title }}
</template>

<script>
export default {
  props: {
    specialArticles: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    showLayerData() {
      const LAYER_LAYOUT_AMOUNT = [4, 3, 4]
      if (this.specialArticles == null || this.specialArticles.length === 0) return []
      let startIndex = 0
      return LAYER_LAYOUT_AMOUNT.map(amount => {
        const endIndex = startIndex + amount
        const list = this.specialArticles.slice(startIndex, endIndex)
        startIndex = endIndex
        return list
      })
    }
  }
}
</script>

<style lang="sass">
@import '@/assets/style.sass'
.rc
  width: 105%
  height: 37vw
  position: relative
  margin-left: -6%
  margin-top: 2.5%
  background: url('../assets/rc.png')
  +bgcon
  background-position: 0 0
  background-size: 100% auto
  box-sizing: border-box
  // +bb
  .rcCard-base
    position: relative
    .img 
      position: absolute
      width: 100%
      height: 100%
  .rcBlock1
    position: absolute
    width: 82.3%
    height: 27%
    left: 12%
    top: 3%
    box-sizing: border-box
    // +bb
    +flexrow
    .rcCard1
      position: relative
      +size(23%, 100%)
      // +bb
      margin-right: 2.3%
      overflow: hidden
      cursor: pointer
      //圓背景
      &:hover
        .rcCircle1
          opacity: 1
          transition: 0.5s
      .rcCircle1
        position: absolute
        +size(100%)
        // border-radius: 100px
        // margin-left: -70%
        // margin-top: -70%
        background-color: rgba(#333, 0.8)
        // padding: 3%
        box-sizing: border-box
        +flexcolumn
        +flexCenter
        opacity: 0
        transition: 0.5s

        .rcTitle1
          position: absolute
          padding: 5%
          font-weight: 800
          box-sizing: border-box
          +size(90%, 77%)
          font-size: 1vw
          letter-spacing: 0.1vw
          line-height: 1.7vw
          // bottom: 26%
          // right: 5%
          color: white
          // +bb
          overflow: hidden
          text-overflow: ellipsis
          display: -webkit-box
          -webkit-line-clamp: 4
          -webkit-box-orient: vertical
  .rcBlock2
    position: absolute
    width: 61%
    height: 27%
    left: 12%
    top: 32%
    // +bb
    +flexrow

    .rcCard2
      position: relative
      +size(35%, 100%)
      // +bb
      margin-right: 2.3%
      overflow: hidden
      cursor: pointer
      //圓背景
      &:hover
        .rcCircle2
          opacity: 1
          transition: 0.5s
      .rcCircle2
        position: absolute
        +size(100%)
        // border-radius: 100px
        // margin-left: -70%
        // margin-top: -70%
        background-color: rgba(#333, 0.8)
        // padding: 3%
        box-sizing: border-box
        +flexcolumn
        +flexCenter
        opacity: 0
        transition: 0.5s

        .rcTitle2
          position: absolute
          padding: 5%
          font-weight: 800
          box-sizing: border-box
          +size(90%, 77%)
          font-size: 1vw
          letter-spacing: 0.1vw
          line-height: 1.7vw
          // bottom: 26%
          // right: 5%
          color: white
          // +bb
          overflow: hidden
          text-overflow: ellipsis
          display: -webkit-box
          -webkit-line-clamp: 4
          -webkit-box-orient: vertical
  .rcBlock3
    position: absolute
    width: 82.3%
    height: 27%
    left: 12%
    top: 61%
    // +bb
    +flexrow
    .rcCard3
      position: relative
      +size(23%, 100%)
      // +bb
      margin-right: 2.3%
      overflow: hidden
      cursor: pointer
      //圓背景
      &:hover
        .rcCircle3
          opacity: 1
          transition: 0.5s
      .rcCircle3
        position: absolute
        +size(100%)
        // border-radius: 100px
        // margin-left: -70%
        // margin-top: -70%
        background-color: rgba(#333, 0.8)
        // padding: 3%
        box-sizing: border-box
        +flexcolumn
        +flexCenter
        opacity: 0
        transition: 0.5s

        .rcTitle3
          position: absolute
          padding: 5%
          font-weight: 800
          box-sizing: border-box
          +size(90%, 77%)
          font-size: 1vw
          letter-spacing: 0.1vw
          line-height: 1.7vw
          // bottom: 26%
          // right: 5%
          color: white
          // +bb
          overflow: hidden
          text-overflow: ellipsis
          display: -webkit-box
          -webkit-line-clamp: 4
          -webkit-box-orient: vertical
</style>


// WEBPACK FOOTER //
// src/components/RCard.vue